import { createContext } from "react";
export const HelpdeskContext = createContext(null);
